import Configuracao from '../util/Configuracao';
import Api from './Api';

class AdvogadoSustentacaoOralApi extends Api {
    async excluirSustentacaoOral(sessaoId, numeroProcesso, oab, codigoParte) {
        let queryParam = `?codigoOrigemSistema=${Configuracao.ID_SISTEMA}`;
        queryParam += codigoParte !== null && codigoParte !== undefined ? '&codigoParte=' + codigoParte : '';
        const url = `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/representantes/${oab}${queryParam}`;

        return this.fetch(url, 'DELETE');
    }

    async incluirSustentacaoOral(sessaoId, numeroProcesso, parte, sequencialPreferencia, novoAdvogado, documentos) {
        const url = `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/representantes?sistemaInscricao=${Configuracao.ID_SISTEMA}`;

        return this.fetch(url, 'POST', {
            codigoDaParte: parte.codigo,
            nomeDaParte: parte.nome,
            advogado: novoAdvogado,
            sequencialPreferencia: sequencialPreferencia,
            denominacaoDaParte: parte.tipo,
            documentos
        });
    }

    async alterarSustentacaoOral(sessaoId, numeroProcesso, oab, parte, novoAdvogado, documentos, sequencialPreferencia) {
        const url = `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/representantes/${oab}?sistemaInscricao=${Configuracao.ID_SISTEMA}`;
        return this.fetch(url, 'PUT', {
            codigoDaParte: parte.codigo,
            advogado: novoAdvogado,
            nomeDaParte: parte.nome,
            sequencialPreferencia: sequencialPreferencia,
            documentos: documentos || []
        });
    }

    async corrigirDadosAdvogado(sessaoId, numeroProcesso, oab, parte, novoAdvogado) {
        const url = `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/representantes/${oab}/dados-advogado?sistemaInscricao=${Configuracao.ID_SISTEMA}`;
        return this.fetch(url, 'PATCH', {
            codigoDaParte: parte.codigo,
            advogado: novoAdvogado,
            nomeDaParte: parte.nome
        });
    }

    async consultarAdvogados(nome, numeroOab, siglaUfOab, letraOab, contem) {
        let query = '';

        if (nome) {
            if (contem) {
                query = `?nomeContem=${nome}`;
            } else {
                query = `?nomeIniciaCom=${nome}`;
            }
        }

        if (numeroOab) {
            query = query === '' ? '?' : `${query}&`;
            query += `numeroOab=${numeroOab}`;
        }

        if (siglaUfOab) {
            query = query === '' ? '?' : `${query}&`;
            query += `siglaUfOab=${siglaUfOab}`;
        }

        if (letraOab) {
            query = query === '' ? '?' : `${query}&`;
            query += `letraOab=${letraOab}`;
        }

        return this.fetch(this.configuracao.urlRepresentantes + encodeURI(query), 'GET');
    }

    async listarDocumentos(inscricaoId) {
        const url = `${this.configuracao.urlSessaoInscricaoAdvogado}${inscricaoId}/documentos`;

        return this.fetchConfig({
            url,
            method: 'GET'
        });
    }

    async uploadDocumento(file, onProgress) {
        const url = `${this.configuracao.urlSessaoInscricaoAdvogado}documentos`;

        const formData = new FormData();
        const encodedFileName = encodeURIComponent(file.name);
        formData.append('file', file, encodedFileName);

        return this.fetchConfig({
            url,
            method: 'POST',
            data: formData,
            addHeader: [
                { parametro: 'Content-type', valor: 'multipart/form-data' },
                { parametro: 'accept', valor: 'application/json, text/plain, */*' }
            ],
            onUploadProgress: ({ total, loaded }) => {
                const porcentagemUpload = Math.round((loaded * 100) / total);
                onProgress(porcentagemUpload);
            }
        });
    }

    async uploadDocumentoParaInscricao(sessaoId, numeroProcesso, representanteId, codigoParte, file, onProgress) {
        const url = `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/representantes/${representanteId}/partes/${codigoParte}/documentos`;

        const formData = new FormData();
        const encodedFileName = encodeURIComponent(file.name);
        formData.append('file', file, encodedFileName);

        return this.fetchConfig({
            url,
            method: 'PUT',
            data: formData,
            addHeader: [
                { parametro: 'Content-type', valor: 'multipart/form-data' },
                { parametro: 'accept', valor: 'application/json, text/plain, */*' }
            ],
            onUploadProgress: ({ total, loaded }) => {
                const porcentagemUpload = Math.round((loaded * 100) / total);
                onProgress(porcentagemUpload);
            }
        });
    }

    async removerDocumento(arquivoId) {
        const url = `${this.configuracao.urlSessaoInscricaoAdvogado}documentos/${arquivoId}`;

        return this.fetchConfig({
            url,
            method: 'DELETE'
        });
    }

    async alterarEstadoInscricao(inscricaoId, codEstado) {
        const url = `${this.configuracao.urlSessaoInscricaoAdvogado}${inscricaoId}/estado/${codEstado}`;
        return this.fetch(url, 'PATCH');
    }

    async alterarPresencaInscricao(inscricaoId, presenca) {
        const url = `${this.configuracao.urlSessaoInscricaoAdvogado}${inscricaoId}/presenca/${presenca}`;
        return this.fetch(url, 'PATCH');
    }

    async alterarModoParticipacaoInscricao(inscricaoId, modoParticipacao) {
        const url = `${this.configuracao.urlSessaoInscricaoAdvogado}${inscricaoId}/modo-participacao/${modoParticipacao}`;
        return this.fetch(url, 'PATCH');
    }
}

export default AdvogadoSustentacaoOralApi;
